export function updateMapElementById(mapElements, updatedElement) {
  const newElements = mapElements.filter(
    (element) => element.id !== updatedElement.id
  );
  return [...newElements, updatedElement];
}
